// extracted by mini-css-extract-plugin
export var active = "_2p-j";
export var cell = "_2p-3";
export var cellLoading = "_2p-6";
export var center = "_2p-10";
export var clickable = "_2p-c";
export var compact = "_2p-4";
export var container = "_2p-8";
export var data = "_2p-a";
export var dataRow = "_2p-b";
export var dateRangeContainer = "_2p-2";
export var downloadIcon = "_2p-v";
export var empty = "_2p-e";
export var filter = "_2p-g";
export var filterContainer = "_2p-16";
export var filterCount = "_2p-i";
export var filterLabel = "_2p-h";
export var filters = "_2p-f";
export var header = "_2p-l";
export var headerButton = "_2p-m";
export var headerContent = "_2p-n";
export var headerLabel = "_2p-p";
export var headerRow = "_2p-u";
export var headerSort = "_2p-o";
export var headerSortAsc = "_2p-r";
export var headerSortContainer = "_2p-q";
export var headerSortDesc = "_2p-s";
export var headerSpacer = "_2p-t";
export var headers = "_2p-w";
export var infoIcon = "_2p-1b";
export var left = "_2p-z";
export var loader = "_2p-y";
export var loaderContainer = "_2p-x";
export var main = "_2p-9";
export var movingGradient = "_2p-7";
export var options = "_2p-0";
export var pageChangeButton = "_2p-1a";
export var pageControl = "_2p-17";
export var pageControlSticky = "_2p-18";
export var pageNumbers = "_2p-19";
export var right = "_2p-11";
export var seamless = "_2p-1";
export var spacer = "_2p-12";
export var table = "_2p-14";
export var tableContainer = "_2p-13";
export var tableFitToParent = "_2p-15";
export var textHeader = "_2p-k";
export var title = "_2p-d";
export var wide = "_2p-5";